import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DraggableBoxOptionsModel} from '../../models/calendar/appointments.models';


@Component({
  selector: 'app-draggable-box',
  templateUrl: './draggable-box.component.html',
  styleUrls: ['./draggable-box.component.scss']
})
export class DraggableBoxComponent implements OnInit {
  @Input() options: DraggableBoxOptionsModel;
  @Output() closePanelEvent = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  closePanel(): void {
    this.closePanelEvent.emit();
  }

}
